/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_Skill_Group_NameInputs */

const en_tables_skill_groups_skill_group_name = /** @type {(inputs: Tables_Skill_Groups_Skill_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Skill Group Name`)
};

const de_tables_skill_groups_skill_group_name = /** @type {(inputs: Tables_Skill_Groups_Skill_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill-Gruppen Name`)
};

/**
* | output |
* | --- |
* | "Groups Skill Group Name" |
*
* @param {Tables_Skill_Groups_Skill_Group_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_skill_group_name = /** @type {((inputs?: Tables_Skill_Groups_Skill_Group_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_Skill_Group_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_skill_group_name(inputs)
	return de_tables_skill_groups_skill_group_name(inputs)
});